import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

const PatientIconPaths = ({ color }) => (
  <g clipPath="url(#clip0_patient_icon)">
    <path
      d="M19.8413 2.81492C23.1911 2.81492 25.9135 5.54137 25.9135 8.89112C25.9135 12.2409 23.1871 14.9673 19.8413 14.9673C16.4956 14.9673 13.7651 12.2409 13.7651 8.89112C13.7651 5.54137 16.4916 2.81492 19.8413 2.81492ZM19.8413 0C14.9313 0 10.9502 3.9811 10.9502 8.89112C10.9502 13.8011 14.9313 17.7822 19.8413 17.7822C24.7513 17.7822 28.7284 13.8011 28.7284 8.89112C28.7284 3.9811 24.7513 0 19.8413 0Z"
      fill={color}
    />
    <path
      d="M20.002 23.2915C28.2377 23.2915 35.1382 27.6184 36.8031 33.3769H3.19694C4.86177 27.6184 11.7623 23.2915 19.998 23.2915M20.002 20.4766C8.95546 20.4766 0 27.4576 0 36.0672C0 36.1074 0 36.1476 0 36.1919H39.992C39.992 36.1516 39.992 36.1114 39.992 36.0672C39.992 27.4576 31.0365 20.4766 19.9899 20.4766H20.002Z"
      fill={color}
    />
  </g>
);

export default function PatientIcon({ size = 40, withCircle = true, color = "#1A1A1A" }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 40 37";
  const iconTransform = withCircle ? "translate(20 21.904)" : "";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <PatientIconPaths color={color} />
      </g>
      <defs>
        <clipPath id="clip0_patient_icon">
          <rect width="40" height="36.1918" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
